// extracted by mini-css-extract-plugin
export default {"main":"Result_main__u9Mdz","img":"Result_img__mBkM3","content":"Result_content__59ET5"};